/**
 * @generated SignedSource<<374f68d258af432024dd25824346f793>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postiesSecondaryContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink">;
  readonly " $fragmentType": "postiesSecondaryContentItemContent";
};
export type postiesSecondaryContentItemContent$key = {
  readonly " $data"?: postiesSecondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"postiesSecondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postiesSecondaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "2ba00f5b740d9b28c575b0eaf5a2dd0e";

export default node;
